export const TRIP_REF_SUBCOVERAGES_IMPORT_TEMPLATE_URL =
    'https://logos-partenaires.s3.eu-west-3.amazonaws.com/template_import_ref_subcoverages.xlsx';

export const TRIP_REF_SUBCOVERAGES_UPDATE_TEMPLATE_URL =
    'https://logos-partenaires.s3.eu-west-3.amazonaws.com/template_import_update_ref_subcoverage.xlsx';

export const extractReferencesSubcovImportError = (error) => {
    let errorMessage = 'Erreur lors du traitement. Veuillez vérifier votre fichier et réessayer.';
    if (error.response?.data) {
        const errorData = error.response.data;
        if (errorData.detail) {
            errorMessage = typeof errorData.detail === 'string'
                ? errorData.detail
                : JSON.stringify(errorData.detail);
        } else if (errorData.message) {
            errorMessage = errorData.message;
        } else if (errorData.error) {
            errorMessage = errorData.error;
        }
    } else if (error.message) {
        errorMessage = error.message;
    }
    return errorMessage;
};

export const isStructuredReferencesSubcovResult = (result) => (
    result != null
    && typeof result === 'object'
    && (
        result.message
        || result.updated_count != null
        || (Array.isArray(result.updated_rows) && result.updated_rows.length > 0)
        || (Array.isArray(result.errors) && result.errors.length > 0)
    )
);

export const isStructuredReferencesSubcovImportResult = (result) => (
    result != null
    && typeof result === 'object'
    && (
        result.message
        || Array.isArray(result.references_created)
        || Array.isArray(result.subcoverages_created)
        || Array.isArray(result.reference_errors)
        || Array.isArray(result.subcoverage_errors)
    )
);

export const parseReferencesSubcovImportResponse = (data) => (
    isStructuredReferencesSubcovImportResult(data) ? data : null
);
